module.exports = __webpack_public_path__ + "img/tree.1055605b.png";